import React, { forwardRef } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import { PatternFormat } from 'react-number-format';

const NumberFormatCustom = forwardRef(function NumberFormatCustom(props, ref) {
    const outLinedInputProps = {
        margin: 'none',
        variant: 'outlined',
        color: 'secondary',
      
    };
    return (
        <PatternFormat            
            valueIsNumericString={true}
            allowEmptyFormatting
            customInput={OutlinedInput}            
            getInputRef={ref}            
            {...outLinedInputProps}
            {...props}
        />
    );
});

export default NumberFormatCustom;